import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";

import i18n from "../i18n.js";
import { selectCurrentUser, selectSeeingCompanyPages } from "../store/index";
import referralsApi from "../api/referrals.js";
import { sendError } from "../errors.js";
import { setLoading } from "../store";
import CompanyReferralSection from "../components/partnerProgramPage/CompanyReferralSection.jsx";
import MarketplaceReferralSection from "../components/partnerProgramPage/MarketplaceReferralSection.jsx";
import TalentReferralSection from "../components/partnerProgramPage/TalentReferralSection.jsx";
import SecondaryNavi from "../components/SecondaryNavi.jsx";

export default function PartnerProgramPage() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const [companyReferralLink, setCompanyReferralLink] = useState(null);
  const [talentReferralLink, setTalentReferralLink] = useState(null);
  const [hasPartnerPage, setHasPartnerPage] = useState(null);
  const seeingCompanyPages = useSelector(selectSeeingCompanyPages);

  useEffect(async () => {
    dispatch(setLoading(true));
    try {
      const { companyReferralLink, talentReferralLink, hasPartnerPage } =
        await referralsApi.referralLinks();
      setCompanyReferralLink(companyReferralLink);
      setTalentReferralLink(talentReferralLink);
      setHasPartnerPage(hasPartnerPage);
    } catch (err) {
      sendError(err);
    }
    dispatch(setLoading(false));
  }, []);

  if (!user) {
    window.location.href = "/login";
    return;
  }
  if (!seeingCompanyPages) {
    window.location.href = "/app";
    return;
  }

  return (
    <AppLayout
      header={<AppHeader title={i18n.t("pages.titles.partner_program")} />}
      footer={<AppFooter />}
    >
      <div class="screenPadding__inner">
        <SecondaryNavi
          items={[
            {
              text: i18n.t("pages.partner_referral.navi.company"),
              to: "/referral",
              end: true,
            },
          ]
            .concat(
              talentReferralLink
                ? [
                    {
                      text: i18n.t("pages.partner_referral.navi.talent"),
                      to: "/referral/talents",
                    },
                  ]
                : []
            )
            .concat([
              {
                text: i18n.t("pages.partner_referral.navi.marketplace"),
                to: "/referral/marketplace",
              },
            ])}
        />
      </div>
      <Routes>
        <Route
          element={
            <CompanyReferralSection referralLink={companyReferralLink} />
          }
          path="/"
        />
        <Route
          element={<TalentReferralSection referralLink={talentReferralLink} />}
          path="/talents"
        />
        <Route
          element={
            <MarketplaceReferralSection hasPartnerPage={hasPartnerPage} />
          }
          path="/marketplace"
        />
      </Routes>
    </AppLayout>
  );
}
